import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { firestore as db } from "../../../../backend/firebaseConfig";

export function useCheck2GuideUrl() {
  const [guideUrl, setGuideUrl] = useState(null);

  useEffect(() => {
    const ref = doc(db, "Compliance", "Check²");

    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) {
          setGuideUrl(snap.data().guide || null);
        } else {
          setGuideUrl(null);
        }
      },
      () => setGuideUrl(null),
    );

    return () => unsub();
  }, []);

  return guideUrl;
}
